/**
 * A line of text held to about two lines, with "Details ▸" to read the rest
 * (proposal 3, kanban 4d4a8707: the reopened box was a wall of text above
 * the decision). Short text shows whole, with no control. Each open and
 * close is recorded under `trackName`.
 */
import { useState } from 'react';

import { trackEvent } from '../../services/portalTracking';
import styles from './IssueSummary.module.css';

/** Text longer than this does not fit two lines of the pane. */
const FOLD_AT_CHARS = 140;

export function FoldLines({
  text,
  className,
  trackName,
  trackMeta,
  testId,
}: {
  text: string;
  className: string;
  trackName: string;
  trackMeta: Record<string, unknown>;
  testId?: string;
}) {
  const [open, setOpen] = useState(false);
  const long = text.length > FOLD_AT_CHARS;
  const folded = long && !open;
  return (
    <div className={`${className} ${styles.fold}`} role="status" data-testid={testId}>
      <div className={folded ? styles.clamp2 : undefined} data-folded={folded || undefined}>
        {text}
      </div>
      {long && (
        <button
          type="button"
          className={styles.detailsLink}
          aria-expanded={open}
          onClick={() => {
            setOpen(!open);
            trackEvent('action', trackName, { ...trackMeta, expanded: !open });
          }}
        >
          {open ? 'Less ▴' : 'Details ▸'}
        </button>
      )}
    </div>
  );
}

export default FoldLines;
